$('.footer__col-name').click(function () {
    if(window.innerWidth > 560)
        return;
    let col = this.closest('.footer__col');
    col.classList.toggle('show');
    $(col).find('.footer__col-content').slideToggle();
});